module.exports = __webpack_public_path__ + "static/Flavor-German-Amarillo-T45-VA18000303-716a3dee5b91a2ba39616d273d205459.pdf";